import { createContext } from 'react';
import { GlobalState, RoomColors } from './Global.interface';

export type GlobalContextProps = {
    globalState: GlobalState;
    setLoggedIn: (data: boolean) => void;
    setIsChangeAccount: (data: boolean) => void;
    setLoading: (data: boolean) => void;
    setRoomColors: (data: RoomColors) => void;
    setProfile: (data: any) => void;
    setTitlePage: (data: string) => void;
};

export const GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);
